export default "__VITE_ASSET__CYLk0hm2__"